module.exports = "https://static.im-cdn.com/mjc/storefront/Comfort/static/media/noProducts.c957185b.svg";